import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddressesPage from '../../components/AddressesPage';
import Menu from '../../components/Menu';

const MODAL_COMPONENTS = {
  'ADDRESSES_PAGE': AddressesPage,
  'MENU_PAGE': Menu,
}

class ModalRoot extends Component {
  shouldComponentUpdate(nextProps, nextState) {
     return  this.props.pageType !== nextProps.pageType
  }

  renderPage = () => {
    const { pageType, pageProps } = this.props;
    if (!pageType) {
      return null;
    }

    const SpecificModal = MODAL_COMPONENTS[pageType]
    return <SpecificModal {...pageProps} />
  }

  render() {
    return (
      <div> 
        {this.renderPage()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    pageType : state.page.pageType,
    pageProps : state.page.pageProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
 
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);



// WEBPACK FOOTER //
// ./src/components/PageRoot/PageRoot.jsx